import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import '../styles/Navbar.css';
import logo from '../assets/favicont.png';
import ThemeToggle from './ThemeToggle'; // 👈 import the new toggle
import ContactModal from './ContactModal';

function Navbar() {
  const [darkMode, setDarkMode] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('dark', darkMode);
  }, [darkMode]);

  const handleContactClick = (e) => {
  e.preventDefault();
  setIsModalOpen(true);
};

  return (
    <>
      <nav className="navbar">
        <div className="navbar-left">
          <Link to="/">
            <img src={logo} alt="Network Slayer Logo" className="navbar-logo" />
          </Link>
        </div>

        <div className="navbar-center nav-links">
          <HashLink smooth to="/#about">About</HashLink>
          <HashLink smooth to="/#skills">Skills</HashLink>
          <HashLink smooth to="/#blog">Blog</HashLink>
          <button type="button" className="contact-link" onClick={handleContactClick}>Contact</button>
        </div>

        <div className="navbar-right">
          <ThemeToggle isDark={darkMode} onChange={setDarkMode} />
        </div>
      </nav>

      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}

export default Navbar;
